/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum WorkflowStatusChangeActionType {
    SEND_EMAIL = 'SendEmail',
    CREATE_FOLLOW_UP_WORKFLOW = 'CreateFollowUpWorkflow',
    SCHEDULE_ACTION = 'ScheduleAction',
    OTHER = 'Other',
}
